import * as React from "react";
function SvgExit(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M31.7 15.3l-6.9-6.9a1 1 0 00-1.4 0 1 1 0 000 1.4l5.2 5.2H15c-.6 0-1 .4-1 1s.4 1 1 1h13.6l-5.2 5.2a1 1 0 000 1.4c.2.2.5.3.7.3s.5-.1.7-.3l6.9-6.9c.2-.2.3-.4.3-.7a1 1 0 00-.3-.7zm-5.6 11.1c-.6 0-1 .4-1 1v2.5H2.7v-28h22.5v2c0 .6.4 1 1 1s1-.4 1-1v-3c0-.6-.4-1-1-1H1.7c-.6 0-1 .4-1 1v30c0 .6.4 1 1 1h24.5c.6 0 1-.4 1-1v-3.5c-.1-.5-.5-1-1.1-1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgExit);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
